module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"BAR Sigma Würzburg","short_name":"BAR Sigma","start_url":"/","background_color":"#212121","theme_color":"#212121","display":"minimal-ui","icon":"src/images/favicon/favicon.png","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"af7df8ab29680026a7a9cbbd3387a639"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
